import CustomComponent from "../../components/customComponent";
import { withRouter } from "../../components/withRouter";
import { withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import { withToast } from "../../App";
import {
    FormInput,
    FormSelect,
    FileInput,
    FormMulticheckbox,
} from "../../components/FormComponents";
import {
    REGEX,
    validateEmail,
    validateName,
    validatePdf,
} from "../../helpers/validation";
import Modal from "../../components/Modal";
import { ROLES } from "../../config";

class EditModal extends CustomComponent {
    constructor(props) {
        super(props);
        this.state = {
            entities: [],
            roles: this.getAvailableRoles(),
            user: {
                firstName: this.props.user.firstName,
                lastName: this.props.user.lastName,
                email: this.props.user.email,
                role: this.props.user.roles.filter(
                    (role) => role !== "ROLE_USER",
                )[0],
                entities_id: this.props.user.permissions.map((p) =>
                    p.entity.id.toString(),
                ),
                company_id: this.props.user.company.id,
            },
            files: {
                rib: false,
                kbis: false,
            },
            isRibUpdated: false,
            isKbisUpdated: false,
            isActive: true,
        };
        this._isMounted = false;
    }

    getAvailableRoles() {
        let mainRole = this.loadMainRole();
        // let filteredRoles = ROLES.filter(role => !['ROLE_ARMATEUR', 'ROLE_NAVIGANT'].includes(role))
        let filteredRoles = ROLES;
        if (mainRole === "ROLE_ADMIN") {
            filteredRoles = filteredRoles.filter(
                (role) => role !== "ROLE_SUPER_ADMIN",
            );
        }

        return filteredRoles.map((role) => ({ value: role, name: role }));
    }

    componentDidMount() {
        this._isMounted = true;
        this.getFiles();
        this.getEntites();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async getFiles() {
        const data = await this.request(
            `/company/${this.state.user.company_id}/files`,
            "GET",
        );
        if (data?.status === "ok" && this._isMounted) {
            this.setState({
                files: {
                    kbis: data.kbis
                        ? { label: "see_kbis_file", url: data.kbis }
                        : false,
                    rib: data.rib
                        ? { label: "see_rib_file", url: data.rib }
                        : false,
                },
            });
        }
    }

    checkFormValidity = () => {
        this.setState({
            formIsValid:
                new RegExp(REGEX.name).test(this.state.user.firstName) &&
                new RegExp(REGEX.name).test(this.state.user.lastName) &&
                new RegExp(REGEX.email).test(this.state.user.email) &&
                ROLES.includes(this.state.user.role) &&
                this.state.user.entities_id.length > 0,
        });
    };

    async getEntites() {
        let url = "/entity/list";
        let method = "GET";
        let data = await this.request(url, method);
        if (data && data.entities) {
            this._isMounted &&
                this.setState({
                    entities: data.entities.map((entity) => ({
                        value: entity.id,
                        name: entity.name,
                    })),
                });
        }
    }

    async afterSubmissionInfo(event) {
        const { t } = this.props;
        event.preventDefault();
        let url = "/user/" + this.props.user.id;
        let method = "POST";
        let csrf = await this.getCsrfToken("/user/csrf");
        let rib = document.querySelectorAll('input[type="file"]')[0].files[0];
        let kbis = document.querySelectorAll('input[type="file"]')[1].files[0];
        let body = new FormData();
        let user = JSON.stringify({
            firstName: this.state.user.firstName,
            lastName: this.state.user.lastName,
            email: this.state.user.email,
            roles: [this.state.user.role],
        });

        body.append("user", user);
        if (this.state.isRibUpdated) body.append("rib_file", rib);
        if (this.state.isKbisUpdated) body.append("kbis_file", kbis);
        body.append("_csrf_token", csrf);

        let data = await this.request(url, method, body, true);
        if (data && data.status === "ok") {
            this.props.addToast(t("userModified"), {
                appearance: "success",
                autoDismiss: true,
                autoDismissTimeout: 4000,
            });
            this.props.onClose();
        }
    }

    render() {
        const { t } = this.props;
        return (
            <Modal open={true} onClose={this.props.onClose}>
                <h1 className="main-title">{t("Users")}</h1>
                <div className="primary-form">
                    <h2 className="primary-form__title">{t("edit_user")}</h2>
                    <hr className="form-divider form-divider--big" />
                    <form onSubmit={(e) => this.afterSubmissionInfo(e)}>
                        <div className="row">
                            <div className="col-sm-6">
                                <FormInput
                                    required
                                    label={t("First name")}
                                    type="text"
                                    name="firstName"
                                    id="firstName"
                                    validation={validateName}
                                    handle={(e) =>
                                        this.handleInputChange(
                                            e,
                                            null,
                                            "user",
                                            this.checkFormValidity,
                                        )
                                    }
                                    value={this.state.user.firstName}
                                />
                            </div>
                            <div className="col-sm-6">
                                <FormInput
                                    required
                                    label={t("Last name")}
                                    type="text"
                                    name="lastName"
                                    id="lastName"
                                    validation={validateName}
                                    handle={(e) =>
                                        this.handleInputChange(
                                            e,
                                            null,
                                            "user",
                                            this.checkFormValidity,
                                        )
                                    }
                                    value={this.state.user.lastName}
                                />
                            </div>
                            <div className="col-sm-6">
                                <FormInput
                                    required
                                    label={t("Email")}
                                    type="email"
                                    name="email"
                                    id="email"
                                    validation={validateEmail}
                                    handle={(e) =>
                                        this.handleInputChange(
                                            e,
                                            null,
                                            "user",
                                            this.checkFormValidity,
                                        )
                                    }
                                    value={this.state.user.email}
                                />
                            </div>
                            <div className="col-sm-6">
                                <FormSelect
                                    required
                                    label={t("Roles")}
                                    id="role"
                                    name="role"
                                    options={this.state.roles}
                                    value={this.state.user.role}
                                    handle={(e) =>
                                        this.handleInputChange(
                                            e,
                                            null,
                                            "user",
                                            this.checkFormValidity,
                                        )
                                    }
                                />
                            </div>
                            <div className="col-md-6">
                                <FileInput
                                    required
                                    id="rib"
                                    name="rib"
                                    validation={validatePdf}
                                    link={this.state.files.rib}
                                    label={t("rib_instruction")}
                                    handle={() => {
                                        this.checkFormValidity();
                                        this.setState({ isRibUpdated: true });
                                    }}
                                    onDelete={() => console.log("delete")}
                                />
                            </div>
                            <div className="col-md-6">
                                <FileInput
                                    required
                                    id="kbis"
                                    name="kbis"
                                    validation={validatePdf}
                                    link={this.state.files.kbis}
                                    label={t("kbis_instruction")}
                                    handle={() => {
                                        this.checkFormValidity();
                                        this.setState({ isKbisUpdated: true });
                                    }}
                                    onDelete={() => console.log("delete")}
                                />
                            </div>
                            <div className="col-12">
                                <hr className="form-divider" />
                                <FormMulticheckbox
                                    disabled
                                    required
                                    label={t("Entity")}
                                    name="entities_id"
                                    options={this.state.entities}
                                    handle={(e) =>
                                        this.handleInputChange(
                                            e,
                                            null,
                                            "user",
                                            this.checkFormValidity,
                                        )
                                    }
                                    checkedItems={this.state.user.entities_id}
                                />
                            </div>
                        </div>

                        <hr className="form-divider form-divider--big" />
                        <div className="primary-form__buttons">
                            <button
                                type="button"
                                onClick={this.props.onClose}
                                className="vnf-btn vnf-btn-secondary vnf-btn-m vnf-btn-outline vnf-btn-bleu-a3"
                            >
                                {t("cancel")}
                            </button>
                            <button
                                type="submit"
                                disabled={!this.state.formIsValid}
                                className="vnf-btn vnf-btn-primary vnf-btn-m vnf-btn-similar-color vnf-btn-bleu-a2 vnf-btn-box-shadow-bleu-a4"
                            >
                                {t("Save")}
                            </button>
                        </div>
                        <p className="primary-form__required-fields">
                            * {t("required_fields")}
                        </p>
                    </form>
                </div>
            </Modal>
        );
    }
}

export default withToast(
    hoistStatics(withTranslation()(withRouter(EditModal)), EditModal),
);
